document.addEventListener('DOMContentLoaded', function() {
    const sidebar = document.getElementById('shopify-section-template--17617415995549__custom-sidebar');
    if (sidebar) {
        const openButton = document.createElement('div');
        openButton.className = 'right-side-open';
        openButton.innerHTML = '<span>&#x27A4;</span>';
        document.body.appendChild(openButton);

        openButton.addEventListener('click', function() {
            sidebar.classList.toggle('active');
        });

        document.addEventListener('click', function(event) {
            if (!sidebar.contains(event.target) && !openButton.contains(event.target)) {
                sidebar.classList.remove('active');
            }
        });
    }

    document.querySelectorAll('.product-form__submit').forEach(function(button) {
        button.addEventListener('click', function(event) {
            showBangleSizePopup();
        });
    });

    function showBangleSizePopup() {
        let popup = document.getElementById('bangle-size-popup');
        if (popup) {
            popup.style.display = 'block';
        }
    }

    window.closeBangleSizePopup = function() {
        let popup = document.getElementById('bangle-size-popup');
        if (popup) {
            popup.style.display = 'none';
        }
    };
});

